export default "__VITE_ASSET__326021b8__"